<template>
  <div>
    <v-dialog v-model="fisrtcard" width="700" persistent>
      <v-card width="700" class="overflow-hidden">
        <v-toolbar flat class="header" dense dark>
          <v-icon>mdi-cash-multiple</v-icon>

          <span v-if="addcardcount == 0" class="ml-3"
            >Load Funds for {{ BindData.full_name }}
          </span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="closedialogEmits((Toggle = 1))">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-card-text class="font-weight-small text">
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Card Balance</b>
                    </span>
                    <br />
                    <span class="caption" v-if="BindData.card_balance != null">
                      MYR <b>{{ BindData.card_balance }}</b>
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Department Name</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="BindData.department_name != null"
                    >
                      {{ BindData.department_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Mobile Number</b>
                    </span>
                    <br />
                    <span class="caption" v-if="BindData.mobile_no != null">
                      +60 {{ BindData.mobile_no }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Department Budget </b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="BindData.department_budget != null"
                    >
                      MYR {{ BindData.department_budget }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Corporate Balance</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="
                        $store.getters.get_getCustDetails.funding_balance !=
                        null
                      "
                    >
                      MYR
                      {{ $store.getters.get_getCustDetails.funding_balance }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Spent Department Budget </b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="BindData.department_budget != null"
                    >
                      MYR {{ BindData.department_spent }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">User Budget </b>
                    </span>
                    <br />
                    <span class="caption" v-if="BindData.user_budget != null">
                      MYR {{ BindData.user_budget }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Spent User Budget </b>
                    </span>
                    <br />
                    <span class="caption" v-if="BindData.user_spent != null">
                      MYR {{ BindData.user_spent }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="mt-n5">
              <v-form ref="loadform">
                <v-row class="ma-5">
                  <v-col cols="12" md="12" lg="12" xl="12">
                    <v-text-field
                      label="Name this Request"
                      v-model="Title"
                      dense
                      outlined
                      :rules="[(v) => !!v || 'Required']"
                      @keydown.space="preventLeadingSpace"
                      maxlength="130"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" lg="12" xl="12" class="mt-n5">
                    <v-text-field
                      label="Load Amount(MYR)"
                      justify="center"
                      align="center"
                      required
                      v-model="LoadAmount"
                      @keypress="isNumber(event)"
                      dense
                      :rules="nameRules"
                      outlined
                      @keydown.space="preventLeadingSpace"
                      maxlength="20"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" lg="12" xl="12" class="mt-n5">
                    <v-text-field
                      label="Comments"
                      justify="center"
                      align="center"
                      hint="optional"
                      required
                      v-model="Comment"
                      dense
                      @keydown.space="preventLeadingSpace"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="8" md="8" class="mt-n5">
                    <v-file-input
                      v-model="file"
                      clearable
                      label="Upload Document"
                      dense
                      @change="beforeaddingfile()"
                      class="mr-3"
                    >
                    </v-file-input>
                  </v-col>
                  <v-spacer />
                  <v-col>
                    <v-btn
                      rounded
                      color="primary"
                      class="gradient-bg2 elevation-10 mr-2 mt-n5 white--text"
                      @click="finalconfirmdailog()"
                    >
                      Load Balance
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="mt-n5">
                  <v-col cols="12" class="mt-n3">
                    <v-list dense class="mt-n4">
                      <v-list-item
                        v-for="(item, i) in new_array"
                        :key="i"
                        class="mt-n2"
                        dense
                      >
                        <v-list-item-icon class="mr-n2">
                          <v-icon class="primary--text ml-5 mr-5 mt-2" x-small
                            >mdi-circle-slice-8</v-icon
                          >
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="mt-2">
                            {{ item.fileName }}</v-list-item-title
                          >

                          <v-icon
                            small
                            class="mt-n5"
                            style="margin-left: 80px"
                            color="red"
                            @click="deleteItem(item)"
                            >mdi-close</v-icon
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-card-text>
        </v-card>

        <v-dialog v-model="finalconfirm" width="400" persistent>
          <v-card class="overflow-hidden">
            <v-toolbar class="elevation-0" dense>
              <span> Are you sure you want to submit ? </span>
              <v-spacer></v-spacer>
              <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
            </v-toolbar>
            <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-row class="mt-2" style="margin-left: 200px">
                <v-btn
                  text
                  width="90px"
                  class="mb-4 red--text"
                  @click="finalconfirm = false"
                  >Back</v-btn
                >
                <v-btn
                  text
                  width="90px"
                  class="mb-4 primary--text"
                  @click="Loadbalance()"
                  >Submit</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  props: {
    fisrtcard: Boolean,
    PropItem: Object,
    // mblnumber: String,
    // name: String,
    // dapartment: String,
    // departmentbudget: String,
    // currentbalance: String,
    // userid: String,
    // spentdeprt: String,
    // spentuser: String,
    // userbudget: String,
    // department: String,
  },

  data: () => ({
    options: {
      acceptedFileTypes: ["image/*"],
      clickable: false,

      adapterOptions: {
        url: "./upload.php",
      },
    },
    packageModel: {
      fileName: "",
      fileUrl: "",
    },

    file: "",
    fileslist: [],
    filename: "",
    new_array: [],
    fileorg: {},
    mediaUrls: [],
    NewUrl: "",
    fileList: [],
    nameRules: [(v) => !!v || "Required"],
    finalconfirm: false,
    addbalancedialog: false,
    LoadFund: [],
    Title: "",
    LoadAmount: "",
    Comment: "",
    addcardcount: 0,
    firstuderdetails: "",
    BindData: {},
  }),
  watch: {
    PropItem(val) {
      this.BindData = val;
    },
    // mblnumber(val){
    //   MblNbr = val
    // },
    // currentbalance(val){
    //   Balnce = val
    // },
    // department(val){
    //   Department = val
    // },
    // departmentbudget(val){
    //   DepartmentDudget = val
    // },
  },
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    back() {
      this.$router.push("/Dashboard");
    },

    closechip(index, files) {
      files.splice(index, 1);
    },

    closedialogEmits(Toggle) {
      this.new_array = [];
      this.mediaUrls = [];

      this.$emit("click", Toggle);
   
      this.$refs.loadform.reset();
    },

    finalconfirmdailog() {
      if (this.$refs.loadform.validate()) {
        this.uploadFile();
        this.finalconfirm = true;
      }
    },

    uploadFile() {
      const self = this;
      this.fileslist.forEach(function (file) {
        self.uploadDoc(file);
      });
    },

    addFile() {
      // this.file = [];
      this.missingDocList = [];
      let docItem = {
        doc_url: this.file,
        docExtn: this.getExtension(this.file.name),
        fileName: this.file.name,
        size: this.file.size,
        doc_type: 1,
        doc_id: 0,
      };
      var reader = new FileReader();

      if (
        this.getExtension(this.file.name) == "jpeg" ||
        this.getExtension(this.file.name) == "jpg" ||
        this.getExtension(this.file.name) == "JPG" ||
        this.getExtension(this.file.name) == "jpeg" ||
        this.getExtension(this.file.name) == "png" ||
        this.getExtension(this.file.name) == "PNG" ||
        this.getExtension(this.file.name) == "webp" ||
        this.getExtension(this.file.name) == "WEBP"
      ) {
        this.uploadDoc(docItem);
        reader.readAsDataURL(this.file);
        this.file = [];
        this.loadingAdd = false;
      } else {
        this.file = [];
        this.loadingAdd = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Invalid File Format",
          color: "red",
        });
      }
    },

    beforeaddingfile() {
      this.addFile();
    },
    preventLeadingSpace(e) {
      // only prevent the keypress if the value is blank
      if (!e.target.value) e.preventDefault();
      // otherwise, if the leading character is a space, remove all leading white-space
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    deleteItem(item) {
      this.editedIndex = this.new_array.indexOf(item);
      // this.fileList.splice(this.indexOfItemToDelete, 1);
      this.new_array.splice(this.editedIndex, 1);
    },

    triggerBrowse(files) {
      // console.warn(files, "files");

      this.$refs.uploader.triggerBrowseFiles();
      this.fileslist = files;
    },
    async Loadbalance() {
      for (let i = 0; i < this.new_array.length; i++) {
        this.NewUrl = this.new_array[i].fileUrl;
        this.mediaUrls.push(this.NewUrl);
      }
  
      var inputData = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "LOADCARDS",
          title: this.Title,
          amount: this.LoadAmount,
          comments: this.Comment,
          user_id: this.BindData.userid,
          media_urls: this.mediaUrls,
          corp_user_id: this.$store.getters.get_userid,
          load_type: 1,
        },
      };

      var responseData = await apiCall(inputData);
    
      if (responseData.data.status == "00") {
        this.addbalancedialog = false;

       
        this.LoadFunds();
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          timeout: 500,
          color: "green",
        });
        this.mediaUrls=[];
        this.closedialogEmits(this.Toggle == 1);
        this.finalconfirm = false;
        this.Title = "";
        this.Comment = "";
        this.LoadAmount = "";
       
      }
    },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },

    async LoadFunds() {
      var inputData = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCARDUSERS",
          search_text: this.search,
          corp_id: this.$store.getters.get_corpid,
          type: 2,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("inputData", inputData);
      // console.log("responseData", responseData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.LoadFund = responseData.data.data;
          this.firstuderdetails = responseData.data.data[0];
          // console.log("firstuderdetailsggg", this.LoadFund[0]);
          // console.log("LoadFund", this.LoadFund);
        }
      } else {
        this.noDataText = responseData.data.status_msg;
      }
      
    },

    async uploadDoc(docItem) {
      let file = docItem.doc_url;
      var inputData = {
        method_name: "ONUPLOAD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "UPLOAD",
          file_name: docItem.fileName,
          doc_id: 0,
          upload_type: 8,
        },
      };

      var responseData = await apiCall(inputData, file);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.doc_url = responseData.data.data.media_url;

          this.fileList.fileName = this.doc_url.split(
            "https://glydpaysol-uat.oss-ap-southeast-3.aliyuncs.com/CPORTAL/Common/"
          )[1];
          var filenamenew = docItem.fileName;
          var url = this.doc_url;

          // this.filee = this.packageModel(filenamenew, this.doc_url);
          this.packageModel = {
            fileName: filenamenew,
            fileUrl: url,
          };

          this.new_array.push(this.packageModel);

          this.fileList.push(this.doc_url);

          for (let i = 0; i < this.fileslist.length; i++) {
            console.warn(this.fileslist[i]);
          }
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
        }
      } else if (responseData.data.status == "INVLDFL") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Entity Too Large",
          color: "red",
        });
      }
    },
  },
};
</script>

<style></style>
